import Decorator from './decorator'
import accounting from 'accounting'

export default class ChargeDecorator extends Decorator {
  clientRate () {
    if (!this.decorated.client_rate) {
      return '–'
    }

    return accounting.formatMoney(this.decorated.client_rate)
  }

  carrierRate () {
    if (!this.decorated.carrier_rate) {
      return '$0'
    }

    return accounting.formatMoney(this.decorated.carrier_rate)
  }

  type () {
    if (this.decorated.type === 'per_tonne') {
      return 'Per Tonne'
    } else if (this.decorated.type === 'single') {
      return 'Single Charge'
    }
  }
}



// WEBPACK FOOTER //
// ./src/decorators/charge.js